export default __webpack_public_path__ + "static/media/About-1.db36f2b2.jpg";